import {
  QueryController,
  QueryControllerStructure,
} from '../../../../queries/QueryController';
import { TApiaFilter, TApiaFunction } from '@apia/util';
import { TResponsiveTableContextProps } from '@apia/table';
import { TableControllerEvents } from '../../../../queries/table/types';
import { QueryColumn } from '../../../../queries/types';
import ApiaApi, { makeApiaUrl } from '../../../../apiaApi';

export type TGenericListColumn = {
  name: string;
  label: string;
  show: boolean;
  order: 'A' | 'D' | '';
};

export class GenericListQuery extends QueryController {
  constructor(public ajaxUrl: string) {
    super(ajaxUrl);
  }

  protected getClearFiltersParameters(): Record<string, unknown> {
    return { ...super.getClearFiltersParameters(), action: 'filter' };
  }

  getTableControllerDefaultProps(): Omit<
    TResponsiveTableContextProps,
    | 'FiltersRenderer'
    | 'SelectionHandler'
    | 'filters'
    | 'columns'
    | 'rows'
    | keyof TableControllerEvents
  > &
    Pick<TResponsiveTableContextProps, 'statesColumns'> {
    return {
      ...super.getTableControllerDefaultProps(),
      isMultiple: true,
    };
  }

  protected getLoadStructureParameters() {
    return {
      ...super.getLoadStructureParameters(),
      ...this.getRefreshParameters(),
    };
  }

  protected getRefreshParameters(): Record<string, unknown> {
    return {
      ...super.getRefreshParameters(),
      action: 'filter',
      isAjax: true,
    };
  }

  protected async getStructure() {
    const result = await ApiaApi.post(
      makeApiaUrl(this.getLoadStructureParameters()),
    );

    if (!result?.data) {
      throw new Error('Cannot load Input query structure');
    }
    //en generic list no hay init entonces el primer llamado (que es un action filter) tiene que hacer el parseRefresh
    super.parseRefreshResponse(result?.data as any);

    return this.parseLoadStructureResponse(result.data);
  }

  public async initialLoad() {
    this.tableController.state.finishedFirstLoad = false;
    if (this.initializing && !this.hasInited) {
      throw new Error('Cannot initialize the query twice');
    }
    this.initializing = true;

    if (!this.hasInited) {
      const structure = await this.getStructure();
      this.structure = structure;
      this.parseStructure(structure);
      this.tableController.updateState({
        props: this.getTableControllerDefaultProps(),
      });

      this.hasInited = true;
      this.initializing = false;

      // if (!this.structure.queryData?.noExecFirstTime) this.refresh();
    }
  }

  protected parseLoadStructureResponse(
    response: any,
  ): QueryControllerStructure {
    const typedResponse = response as TApiaFunction<{
      result: {
        columns: { column: QueryColumn };
        filters: {
          filter: TApiaFilter[];
        };
      };
    }>;

    return super.parseLoadStructureResponse({
      columns: { ...typedResponse.function.messages.result.columns },
      filters: {
        ...typedResponse.function.messages.result.filters,
        runFiltersAutomatically: true,
      },
    });
  }
}
